<template>
    <div :class="itemClasses">
        <div :class="headerClasses" @click="toggle">
            <Icon type="chevron-down"></Icon>
            <slot></slot>
        </div>
        <collapse-transition>
            <div :class="contentClasses" v-show="isActive">
                <div :class="boxClasses"><slot name="content"></slot></div>
            </div>
        </collapse-transition>
    </div>
</template>
<script>
    import CollapseTransition from './collapse-transition';
    const prefixCls = 'm-collapse';
    export default {
        name: 'Panel',
        components: { CollapseTransition },
        props: {
            name: {
                type: String
            },
            gutter: {
                type: Boolean,
                default: true
            }
        },
        data () {
            return {
                index: 0,
                isActive: true
            };
        },
        computed: {
            itemClasses () {
                return [
                    `${prefixCls}-item`,
                    {
                        [`${prefixCls}-item-active`]: this.isActive
                    }
                ];
            },
            headerClasses () {
                return `${prefixCls}-header`;
            },
            contentClasses () {
                return [{
                   [`${prefixCls}-content`]: this.gutter
                }];
            },
            boxClasses () {
                return [{
                   [`${prefixCls}-content-box`]: this.gutter
                }];
            }
        },
        methods: {
            toggle () {
               this.isActive = !this.isActive;
            }
        }
    };
</script>
<style lang="less" scoped>
    .m-collapse-item.m-collapse-item-active>.m-collapse-header>i {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
        transition: -webkit-transform .2s ease-in-out;
        transition: transform .2s ease-in-out;
        transition: transform .2s ease-in-out,-webkit-transform .2s ease-in-out;
    }
    .m-collapse-header>i{
        font-weight: 700;
        margin-right: 10px;
    }
    .m-collapse-header {
        height: 40px;
        line-height: 40px;
        padding-left: 25px;
        color: #666;
        cursor: pointer;
        position: relative;
        border-bottom: 1px solid #dddee1;
    }
    .m-collapse-item {
        background-color: #F2F2F2;
        border: 1px solid #dddee1;
    }
</style>